import React from "react";
import { boxesMainCategoryKey, boxesSubCategoryKey, boxigoBoxesSubCategoryKey } from "../../constants/inventory";
import { CustomSVGIcon } from "../svg/category/custom";
import { ElectronicSVGIcon } from "../svg/category/electronic";
import { FurnitureSVGIcon } from "../svg/category/furniture";
import { OtherAppliancesSVGIcon } from "../svg/category/otherAppliances";
import { VehicleSVGIcon } from "../svg/category/vehicle";
import { TrolleySVGIcon } from "../svg/category/trolley";

export const getTotalItemsCount = (inventoryData) => {
    let totalCount = 0;
    inventoryData.get("inventory").forEach((mainCategory, index) => {
        totalCount += getCategoryCount(mainCategory);
    });
    totalCount = totalCount + getCustomItemsCount(inventoryData);
    return totalCount;
};

export const getCategoryCount = (mainCategory) => {
    let count = 0;
    mainCategory.get("category").forEach((data) => {
        data.get("items").forEach((item) => {
            count = count + item.get("qty");
        });
    });
    return count;
};

export const getCustomItemsCount = (inventoryData) => {
    const customItemsList = inventoryData.getIn(["customItems", "items"]);
    let count = 0;
    customItemsList.forEach((item) => {
        count = count + parseInt(item.get("item_qty"));
    });
    return count;
};

export const getSubCategoryCount = (subCategory) => {
    const itemsList = subCategory.get("items");
    let count = 0;
    itemsList.forEach((item, index) => {
        count += item.get("qty");
    });
    return count;
};

export const getBoxesCount = (inventoryData) => {
    let boxesCount = 0;
    inventoryData.get("inventory").forEach((mainCategory) => {
        if (mainCategory.get("name").includes(boxesMainCategoryKey)) {
            mainCategory.get("category").forEach((subCategory) => {
                const subCategoryName = subCategory.get("name");
                if (subCategoryName === boxesSubCategoryKey || subCategoryName === boxigoBoxesSubCategoryKey) {
                    subCategory.get("items").forEach((item) => {
                        boxesCount += parseInt(item.get("qty"));
                    });
                }
            });
        }
    });
    return boxesCount;
};

export const getVolumeCount = (inventoryData) => {
    let totalVolume = 0;
    inventoryData.get("inventory").forEach((mainCategory) => {
        mainCategory.get("category").forEach((data) => {
            data.get("items").forEach((item) => {
                const value = Number(item.get("total_item_volume_cuft"));
                totalVolume += value;
            });
        });
    });
    const customItemsList = inventoryData.getIn(["customItems", "items"]);
    customItemsList.forEach((item) => {
        const value = Number(item.get("total_item_volume_cuft"));
        totalVolume += value;
    });
    return Number(totalVolume.toFixed(2));
};

export const getAreaCount = (inventoryData) => {
    let totalArea = 0;
    inventoryData.get("inventory").forEach((mainCategory) => {
        mainCategory.get("category").forEach((data) => {
            data.get("items").forEach((item) => {
                const value = Number(item.get("total_item_area_sqft"));
                totalArea += value;
            });
        });
    });
    const customItemsList = inventoryData.getIn(["customItems", "items"]);
    customItemsList.forEach((item) => {
        const value = Number(item.get("total_item_area_sqft"));
        totalArea += value;
    });
    return Number(totalArea.toFixed(2));
};

export const categoryIcons = {
    furniture: (status = "in-active") => <FurnitureSVGIcon status={status} />,
    electronics: (status = "in-active") => <ElectronicSVGIcon status={status} />,
    vehicle: (status = "in-active") => <VehicleSVGIcon status={status} />,
    other_appliances: (status = "in-active") => <OtherAppliancesSVGIcon status={status} />,
    boxes_trolley: (status = "in-active") => <TrolleySVGIcon status={status} />,
    boxes: (status = "in-active") => <TrolleySVGIcon status={status} />,
    custom: (status = "in-active") => <CustomSVGIcon status={status} />,
};